module.exports = __webpack_public_path__ + "img/btn_contact_.d01c8189.png";